var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c("div", [
        _c("a", { attrs: { href: _vm.$ceres.urls.myAccount } }, [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18.5",
                height: "20",
                viewBox: "0 0 18.501 20"
              }
            },
            [
              _c("path", {
                attrs: {
                  id: "user-solid",
                  d:
                    "M9.251,10a5.149,5.149,0,0,0,5.286-5A5.149,5.149,0,0,0,9.251,0,5.149,5.149,0,0,0,3.965,5,5.149,5.149,0,0,0,9.251,10Zm2.094,1.875H7.157A6.972,6.972,0,0,0,0,18.646,1.4,1.4,0,0,0,1.431,20H17.07A1.392,1.392,0,0,0,18.5,18.646,6.972,6.972,0,0,0,11.344,11.876Z",
                  fill: "#fff"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.$translate("Ceres::Template.myAccountHello", {
                  username: _vm.username
                })
              )
            )
          ])
        ])
      ])
    : !_vm.isLoggedIn
    ? _c("div", { staticClass: "login-leftmodal login-leftmodal-trigger" }, [
        _c("a", [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                width: "18.5",
                height: "20",
                viewBox: "0 0 18.501 20"
              }
            },
            [
              _c("path", {
                attrs: {
                  id: "user-solid",
                  d:
                    "M9.251,10a5.149,5.149,0,0,0,5.286-5A5.149,5.149,0,0,0,9.251,0,5.149,5.149,0,0,0,3.965,5,5.149,5.149,0,0,0,9.251,10Zm2.094,1.875H7.157A6.972,6.972,0,0,0,0,18.646,1.4,1.4,0,0,0,1.431,20H17.07A1.392,1.392,0,0,0,18.5,18.646,6.972,6.972,0,0,0,11.344,11.876Z",
                  fill: "#fff"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$translate("Ceres::Template.login")))])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }